import { render, staticRenderFns } from "./booklet_publication.vue?vue&type=template&id=c4bdc3a6"
import script from "./booklet_publication.vue?vue&type=script&lang=js"
export * from "./booklet_publication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports